import { useAuthService } from "@b2ag/auth";
import axios from "axios";
const STATUS_CODE = {
    SITE_EN_MAINTENANCE: 580,
};
export async function setAuthTokenOnRequestInterceptor(config) {
    const authService = useAuthService();
    const accessToken = await authService.getAccessToken();
    if (accessToken !== null && config.headers) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
}
export function createAxiosClientAnonymous(baseUrl, { timeout = 20000, accept = "application/json", callerId, i18n } = {}) {
    const axiosInstance = axios.create({
        baseURL: `${baseUrl}`,
        timeout,
        headers: {
            Accept: accept,
            ...(callerId ? { "x-caller-id": callerId } : {}),
        },
    });
    axiosInstance.interceptors.request.use((request) => {
        if (i18n && i18n.locale)
            request.headers["Idf-Locale"] = i18n.locale;
        return request;
    });
    axiosInstance.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === STATUS_CODE.SITE_EN_MAINTENANCE) {
            window.location.href = "/maintenance.html";
            return;
        }
        return Promise.reject(error);
    });
    return axiosInstance;
}
export function createAxiosClientWithAladinBearer(baseUrl, { timeout = 20000, ...rest } = {}) {
    const client = createAxiosClientAnonymous(baseUrl, { timeout, ...rest });
    client.interceptors.request.use(setAuthTokenOnRequestInterceptor);
    return client;
}
export { HttpStatusCode, isAxiosError, } from "axios";
//# sourceMappingURL=index.js.map